<template>
  <section class="form-list">
    <el-form
      ref="form"
      label-position="right"
      label-width="160px"
      class="form"
    >
      <div class="table-title table-title-top">{{ updateInfo.apply.add_time ? '申请' : '修改人' }}信息</div>
      <template v-if="updateInfo.apply.add_time">
        <el-form-item label="申请时间">{{ updateInfo.apply.add_time | timeToYmdHi }}</el-form-item>

        <el-form-item label="申请者">
          <v-avatar-nickname v-if="updateInfo.apply.administrator_id" :value="updateInfo.apply.avatar" :nickname="updateInfo.apply.nickname" :is-center="false"/>
          <span v-else class="success-color">学员本人</span>
        </el-form-item>

        <el-form-item label="申请门店">{{ updateInfo.apply.store_name }}</el-form-item>

        <el-form-item label="申请原因">
          <span v-if="updateInfo.apply.update_remark" class="danger-color">{{ updateInfo.apply.update_remark }}</span>
          <span v-else class="info-color">未填写</span>
        </el-form-item>

        <el-form-item v-if="(updateInfo.apply.remark_files || []).length" label="上传凭证">
          <v-remark-file-list :files="updateInfo.apply.remark_files || []"/>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="修改者">
          <v-avatar-nickname v-if="updateInfo.administrator.id" :value="updateInfo.administrator.avatar" :nickname="updateInfo.administrator.nickname" :is-center="false"/>
          <span v-else-if="updateInfo.operator_source === 1" class="success-color">学员本人</span>
          <span v-else-if="updateInfo.operator_source === 2" class="info-color">系统自动</span>
          <span v-else class="success-color">后台系统</span>
        </el-form-item>

        <el-form-item label="修改时间">
          <span class="success-color">{{ updateInfo.add_time | timeToYmdHi }}</span>
        </el-form-item>
      </template>


      <div class="table-title">修改记录</div>

      <el-form-item v-if="updateInfo.update_type === 6" label="停卡时长">
        <span v-if="updateInfo.is_unlimited_stop" class="primary-color">无固定期限（历史手动停卡，不自动开卡；提前开卡时按实际停卡天数顺延）</span>
        <span v-else class="primary-color">{{ updateInfo.stop_days | toYuan }} 天（到期自动开卡，停卡期间不可预约）</span>
      </el-form-item>
      <el-form-item v-if="updateInfo.update_type === 7" :label="updateInfo.operator_source === 2 ? '到期自动开卡' : '提前开卡'">
        <span class="primary-color">停卡已解除，已停时长顺延至有效期</span>
      </el-form-item>

      <div class="field-group-label">基础信息</div>

      <el-form-item label="所属学员">
        <template v-if="updateInfo.old_student.id !== updateInfo.student.id">
          <v-avatar-nickname
            v-if="updateInfo.old_student.id"
            :value="updateInfo.old_student.selfie"
            :nickname="`${updateInfo.old_student.student_name}${updateInfo.old_student.is_del ? '（已注销）' : ''}`"
            :is-center="false"
            :link-page-name="RouteConfig.studentDetail.name"
            :link-page-id="updateInfo.old_student.id"
          />
          <v-icon name="arrow-right"/>
          <v-avatar-nickname
            :value="updateInfo.student.selfie"
            :nickname="`${updateInfo.student.student_name}${updateInfo.student.is_del ? '（已注销）' : ''}`"
            :is-center="false"
            :link-page-name="RouteConfig.studentDetail.name"
            :link-page-id="updateInfo.student.id"
          />
        </template>
        <v-avatar-nickname
          v-else
          :value="updateInfo.old_student.selfie"
          :nickname="`${updateInfo.old_student.student_name}${updateInfo.old_student.is_del ? '（已注销）' : ''}`"
          :is-center="false"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="updateInfo.old_student.id"
        />
      </el-form-item>

      <el-form-item label="办卡日期">
        <template v-if="updateInfo.old_register_time !== updateInfo.register_time">
          <span class="user-select">{{ updateInfo.old_register_time | timeToYmd }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ updateInfo.register_time | timeToYmd }}</span>
        </template>
        <template v-else>{{ updateInfo.register_time | timeToYmd }}</template>
      </el-form-item>

      <el-form-item label="办卡门店">
        {{ updateInfo.store_name }}
      </el-form-item>

      <el-form-item label="课卡名称">
        <template v-if="updateInfo.old_card_name !== updateInfo.card_name">
          <span class="user-select">{{ updateInfo.old_card_name }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ updateInfo.card_name }}</span>
        </template>
        <template v-else>{{ updateInfo.card_name }}</template>
      </el-form-item>

      <el-form-item label="禁止预约专栏">
        <template v-if="updateInfo.old_is_disable_column !== updateInfo.is_disable_column">
          <span class="user-select">{{ updateInfo.old_is_disable_column ? '是' : '否' }}</span>
          <v-icon name="arrow-right"/>
          <span :class="updateInfo.is_disable_column ? 'danger-color user-select' : 'primary-color user-select'">{{ updateInfo.is_disable_column ? '是' : '否' }}</span>
        </template>
        <template v-else>
          <span v-if="updateInfo.is_disable_column" class="danger-color">是</span>
          <span v-else>否</span>
        </template>
      </el-form-item>

      <el-form-item label="课卡类型">
        <template v-if="updateInfo.old_card_type_name !== updateInfo.card_type_name">
          <span class="user-select">{{ updateInfo.old_card_type_name }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ updateInfo.card_type_name }}</span>
        </template>
        <template v-else>{{ updateInfo.card_type_name }}</template>
      </el-form-item>

      <div class="field-group-label">使用规则</div>

      <el-form-item label="适用门店">
        <template v-if="updateInfo.old_store_names !== updateInfo.store_names">
          <span class="user-select">{{ updateInfo.old_store_names || '全国通用' }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ updateInfo.store_names || '全国通用' }}</span>
        </template>
        <template v-else>{{ updateInfo.store_names || '全国通用' }}</template>
      </el-form-item>

      <template v-if="updateInfo.store_names">
        <el-form-item label="适用门店限制天数">
          <template v-if="updateInfo.old_store_limit_expire_days !== updateInfo.store_limit_expire_days">
            <span class="user-select">{{ updateInfo.old_store_limit_expire_days }} 天</span>
            <v-icon name="arrow-right"/>
            <span class="primary-color user-select">{{ updateInfo.store_limit_expire_days }} 天</span>
          </template>
          <template v-else>{{ updateInfo.store_limit_expire_days }} 天</template>
        </el-form-item>

        <el-form-item label="适用门店失效日期">
          <template v-if="updateInfo.old_store_limit_expire_time !== updateInfo.store_limit_expire_time">
            <span class="user-select">{{ updateInfo.old_store_limit_expire_time | timeToYmdHi }}</span>
            <v-icon name="arrow-right"/>
            <span class="primary-color user-select">{{ updateInfo.store_limit_expire_time | timeToYmdHi }}</span>
          </template>
          <template v-else>{{ updateInfo.store_limit_expire_time | timeToYmdHi }}</template>
        </el-form-item>
      </template>

      <el-form-item label="次数限定">
        <template v-if="updateInfo.old_is_number_limit !== updateInfo.is_number_limit">
          <span class="user-select">{{ updateInfo.old_is_number_limit ? '是' : '否' }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ updateInfo.is_number_limit ? '是' : '否' }}</span>
        </template>
        <template v-else>{{ updateInfo.is_number_limit ? '是' : '否' }}</template>
      </el-form-item>

      <el-form-item label="剩余次数">
        <template v-if="updateInfo.old_expire_number !== updateInfo.expire_number">
          <span class="user-select">{{ updateInfo.old_expire_number / 100 }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ updateInfo.expire_number | toYuan }}</span>
        </template>
        <template v-else>{{ updateInfo.expire_number | toYuan }}</template>
      </el-form-item>

      <el-form-item label="有效天数">
        <template v-if="updateInfo.old_expire_days !== updateInfo.expire_days">
          <span class="user-select">{{ updateInfo.old_expire_days }} 天</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ updateInfo.expire_days }} 天</span>
        </template>
        <template v-else>{{ updateInfo.expire_days }} 天</template>
      </el-form-item>

      <el-form-item label="过期时间">
        <template v-if="updateInfo.old_expire_time !== updateInfo.expire_time">
          <span v-if="updateInfo.old_expire_time" class="user-select">{{ updateInfo.old_expire_time | timeToYmdHi }}</span>
          <span v-else class="info-color">未开卡</span>
          <v-icon name="arrow-right"/>
          <span v-if="updateInfo.expire_time" class="primary-color user-select">{{ updateInfo.expire_time | timeToYmdHi }}</span>
          <span v-else class="info-color">未开卡</span>
        </template>
        <template v-else>
          <template v-if="updateInfo.expire_time">{{ updateInfo.expire_time | timeToYmdHi }}</template>
          <span v-else class="info-color">未开卡</span>
        </template>
      </el-form-item>

      <div class="field-group-label">支付信息</div>

      <el-form-item label="收款方式">
        <template v-if="updateInfo.old_card_payment_mode_name !== updateInfo.card_payment_mode_name">
          <span class="user-select">{{ updateInfo.old_card_payment_mode_name }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ updateInfo.card_payment_mode_name }}</span>
        </template>
        <template v-else>{{ updateInfo.card_payment_mode_name }}</template>
      </el-form-item>

      <el-form-item v-if="updateInfo.old_receipt || updateInfo.receipt" label="收款凭证">
        <template v-if="updateInfo.old_receipt !== updateInfo.receipt">
          <div class="diff-flex">
            <v-img v-if="updateInfo.old_receipt" class="table-cover-phone" :value="updateInfo.old_receipt"/>
            <span v-else class="info-color">无</span>
            <v-icon name="arrow-right" class="diff-arrow primary-color"/>
            <v-img v-if="updateInfo.receipt" class="table-cover-phone" :value="updateInfo.receipt"/>
            <span v-else class="info-color">无</span>
          </div>
        </template>
        <template v-else>
          <v-img v-if="updateInfo.receipt" class="table-cover-phone" :value="updateInfo.receipt"/>
        </template>
      </el-form-item>

      <el-form-item v-if="updateInfo.old_card_payment_mode_id === paymentModes.youZan.value || updateInfo.card_payment_mode_id === paymentModes.youZan.value" label="有赞券码">
        <template v-if="updateInfo.old_you_zan_number !== updateInfo.you_zan_number">
          <span class="user-select">{{ updateInfo.old_you_zan_number }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ updateInfo.you_zan_number }}</span>
        </template>
        <template v-else>{{ updateInfo.you_zan_number }}</template>
      </el-form-item>

      <el-form-item label="实际收款">
        <template v-if="updateInfo.old_actual_payment !== updateInfo.actual_payment">
          <span class="user-select">{{ updateInfo.old_actual_payment / 100 }}</span>
          <v-icon name="arrow-right"/>
          <span class="income-color user-select">{{ updateInfo.actual_payment | toYuan }}</span>
        </template>
        <template v-else><span class="income-color">{{ updateInfo.actual_payment | toYuan }}</span></template>
      </el-form-item>

      <el-form-item v-if="updateInfo.old_payment_remark || updateInfo.payment_remark" label="收款备注">
        <template v-if="updateInfo.old_payment_remark !== updateInfo.payment_remark">
          <span class="user-select">{{ updateInfo.old_payment_remark }}</span>
          <v-icon name="arrow-right"/>
          <span class="warning-color user-select">{{ updateInfo.payment_remark }}</span>
        </template>
        <template v-else><span class="warning-color">{{ updateInfo.payment_remark }}</span></template>
      </el-form-item>

      <el-form-item label="备注文件">
        <template v-if="(updateInfo.old_remark_files || []).length || (updateInfo.remark_files || []).length">
          <div v-if="JSON.stringify(updateInfo.old_remark_files || []) !== JSON.stringify(updateInfo.remark_files || [])" class="remark-diff">
            <template v-if="(updateInfo.old_remark_files || []).length">
              <v-remark-file-list :files="updateInfo.old_remark_files || []"/>
            </template>
            <span v-else class="info-color">未上传</span>
            <v-icon name="arrow-right" class="remark-diff-arrow primary-color"/>
            <template v-if="(updateInfo.remark_files || []).length">
              <v-remark-file-list :files="updateInfo.remark_files || []"/>
            </template>
            <span v-else class="info-color">未上传</span>
          </div>
          <v-remark-file-list v-else :files="updateInfo.remark_files || []"/>
        </template>
        <span v-else class="info-color">未上传</span>
      </el-form-item>

      <el-form-item label="所补差价">
        <span v-if="updateInfo.update_payment > 0" class="income-color">{{ updateInfo.update_payment | toYuan }}</span>
        <span v-else-if="updateInfo.update_payment < 0" class="pay-color">{{ updateInfo.update_payment | toYuan }}</span>
        <span v-else class="info-color">未收款</span>
      </el-form-item>

      <el-form-item label="补差价支付方式">
        <span v-if="updateInfo.update_payment_mode" class="primary-color">{{ findPaymentModeName(updateInfo.update_payment_mode) }}</span>
        <span v-else class="info-color">未收款</span>
      </el-form-item>

      <template v-if="updateInfo.administrator.id && updateInfo.apply.add_time">
        <div class="table-title">审核信息</div>
        <el-form-item v-if="canViewReviewInfo" label="审核者">
          <v-avatar-nickname :value="updateInfo.administrator.avatar" :nickname="updateInfo.administrator.nickname" :is-center="false"/>
        </el-form-item>
        <el-form-item v-if="canViewReviewInfo" label="审核时间">
          <span class="success-color">{{ updateInfo.add_time | timeToYmdHi }}</span>
        </el-form-item>
        <el-form-item v-if="isAdministrator" label="审核备注">
          <span v-if="updateInfo.apply.review_remark" class="danger-color">{{ updateInfo.apply.review_remark }}</span>
          <span v-else class="info-color">未填写</span>
        </el-form-item>
      </template>


      <el-form-item>
        <el-button @click="RouteConfig.cardUpdateRecordList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { applyStates } from "@/enums/applyStates";
import { mapGetters } from 'vuex';
import { show } from "@/api/card-update-record";
import { paymentModes, findPaymentModeName } from "@/enums/paymentModes";

export default {
  name: RouteConfig.cardUpdateRecordDetail.name,
  data: () => ({
    RouteConfig,
    applyStates,
    paymentModes,
    isSaving: false,
    isPassing: false,
    isRejecting: false,
    isRevoking: false,
    isLoading: false,
    isLoadingError: false,
    updateInfo: {
      card_id: 0,
      add_time: 0,
      is_reviewing: 0,
      update_type: 0,
      is_stop: 0,
      stop_days: 0,
      is_unlimited_stop: false,
      operator_source: 0,
      student_id: 0,
      selfie: '',
      student_name: '',
      add_store_name: '',
      card_name: '',
      card_type_name: '',
      expire_number: '',
      expire_days: '',
      register_time: '',
      expire_time: '',
      store_limit_expire_days: 0,
      store_limit_expire_time: 0,
      actual_payment: '',
      store_name: '',
      store_names: '',
      card_payment_mode_name: '',
      card_payment_mode_id: 0,
      you_zan_number: '',
      payment_remark: '',
      update_remark: '',
      update_payment: 0,
      update_payment_mode: 0,
      is_disable_column: 0,
      old_is_disable_column: 0,
      apply_state: applyStates.review.value,

      store_name_card: '',
      store_name_update: '',

      old_student_id: 0,
      is_number_limit: 0,
      old_is_number_limit: 0,
      old_expire_number: 0,
      old_expire_days: '',
      old_expire_time: '',
      old_store_limit_expire_days: 0,
      old_store_limit_expire_time: '',
      old_card_payment_mode_name: '',
      old_card_payment_mode_id: 0,
      old_actual_payment: 0,
      old_payment_remark: '',
      old_remark_files: [],
      remark_files: [],
      receipt: '',
      old_receipt: '',
      old_card_type_name: '',
      old_card_name: '',
      old_register_time: '',
      old_store_names: '',
      old_you_zan_number: '',

      old_student: {
        id: 0,
        student_name: '',
        selfie: '',
        is_del: 0,
      },
      student: {
        id: 0,
        student_name: '',
        selfie: '',
        is_del: 0,
      },
      administrator: {
        id: 0,
        avatar: '',
        nickname: '',
      },
      apply: {
        add_time: 0,
        administrator_id: 0,
        avatar: '',
        nickname: '',
        store_name: '',
        update_remark: '',
        review_remark: '',
        store_id: 0,
        remark_files: [],
      },
    },
  }),
  computed: {
    ...mapGetters(['isAdministrator', 'userStoreId']),
    canViewReviewInfo() {
      return this.isAdministrator || this.userStoreId === this.updateInfo.store_id;
    },
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    findPaymentModeName,
    async show() {
      this.isLoading = true;
      this.isLoadingError = false;

      const { isError, data } = await show(this.id);
      if (isError) {
        this.isLoading = false;
        this.isLoadingError = true;
        return;
      }

      const { updateInfo } = this;
      const updateCardInfo = {};
      Object.keys(data).forEach(key => {
        if (key in updateInfo) updateCardInfo[key] = data[key];
      });
      updateCardInfo.old_card_payment_mode_name = findPaymentModeName(updateCardInfo.old_card_payment_mode_id);
      updateCardInfo.card_payment_mode_name = findPaymentModeName(updateCardInfo.card_payment_mode_id);
      Object.assign(updateInfo, updateCardInfo);
      this.isLoading = false;
    },
  },
};
</script>

<style src="./card-detail.css" scoped/>
<style scoped>
.remark-diff,
.diff-flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.remark-diff-arrow,
.diff-arrow {
  color: #409EFF !important;
  flex-shrink: 0;
}
</style>
